'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var table_module = require('./table.module.scss.js');

var hasFooter = function (schema) {
    return schema.some(function (col) { return 'footerId' in col; });
};
var getDisplayClass = function (col) {
    var hideOnMobile = col.hideOnMobile, hideOnDesktop = col.hideOnDesktop;
    if (hideOnMobile && hideOnDesktop) {
        return table_module.default['d-none-not-important'];
    }
    if (hideOnMobile) {
        return "".concat(table_module.default['d-none-not-important'], " ").concat(table_module.default['d-lg-table-cell-not-important']);
    }
    if (hideOnDesktop) {
        return table_module.default['d-lg-none-not-important'];
    }
    return '';
};
var showRowNotes = function (item, override) {
    if (override === void 0) { override = false; }
    if (item.rowNotes && (override || item.showRowNotes)) {
        return true;
    }
    return false;
};

exports.getDisplayClass = getDisplayClass;
exports.hasFooter = hasFooter;
exports.showRowNotes = showRowNotes;
//# sourceMappingURL=utils.js.map
